import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeDuplicateNames'
})
export class RemoveDuplicateNamesPipe implements PipeTransform {
    transform(objects: any[] | null | undefined, pathToNames?: string): any[] {
        if (!objects) return [];

        const out: any[] = [];

        for (const obj of objects) {
            // Avoid duplicates by reference
            if (!out.includes(obj)) {
                out.push(obj);
            }

            for (let j = 0; j < out.length; j++) {
                if (!pathToNames) {
                    // Compare top-level NAME fields
                    if (obj.NAME === out[j].NAME && obj.ID !== out[j].ID) {
                        out.splice(out.length - 1, 1); // remove duplicate
                        break;
                    }
                } else {
                    // Compare nested property: e.g. object[pathToNames].NAME
                    const nameA = obj?.[pathToNames]?.NAME;
                    const nameB = out[j]?.[pathToNames]?.NAME;

                    if (nameA === nameB && obj.ID !== out[j].ID) {
                        out.splice(out.length - 1, 1);
                        break;
                    }
                }
            }
        }

        return out;
    }
}
